import withEntity from '@/entity/components/with-entity';

import DeviceInsights from './device-insights';

export default withEntity(DeviceInsights);
